import script from "./InvitationView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitationView.vue?vue&type=script&setup=true&lang=js"

import "./InvitationView.vue?vue&type=style&index=0&id=ac11acd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac11acd8"]])

export default __exports__